/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
} from "../../runtime/index.jsx";
export function RedireccionInicio(e) {
  return (
    <button
      key={e.texto}
      type={`button`}
      onClick={e.alHacer}
      className={
        e.principal
          ? `min-h-11 rounded-full bg-(--accent) px-5 py-2 text-sm font-medium text-(--accent-fg) transition hover:opacity-90`
          : `min-h-11 rounded-full border border-(--border) px-5 py-2 text-sm font-medium text-(--text-h) transition hover:bg-(--accent-bg)`
      }
      children={e.texto}
    />
  );
}
